import { defineStore } from 'pinia';
import type { Banner } from '~/handlers/ports/api-fetch-banners.port';

export const useBannersStore = defineStore('ap.banners', () => {
  const mainBanners = ref<Banner[]>([]);
  const homeBanners = ref<Banner[]>([]);
  const guestBanner = ref<Banner | null>(null);
  const loading = ref(false);

  function setGuestBanner(banner: Banner | null) {
    guestBanner.value = banner;
  }

  function setMainBanners(newBanners: Banner[]) {
    mainBanners.value = newBanners;
  }

  function setHomeBanners(newBanners: Banner[]) {
    homeBanners.value = newBanners;
  }

  function setBanners(data: { mainBanners: Banner[]; homeBanners: Banner[] }) {
    mainBanners.value = data.mainBanners;
    homeBanners.value = data.homeBanners;
  }

  const hasMainBanners = computed(() => mainBanners.value.length > 0);
  const hasHomeBanners = computed(() => homeBanners.value.length > 0);

  return {
    mainBanners,
    homeBanners,
    guestBanner,
    loading,
    setMainBanners,
    setHomeBanners,
    setBanners,
    setGuestBanner,
    hasMainBanners,
    hasHomeBanners,
  };
});
